import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import MapView from './components/MapView';
import QRCodePanel from './components/QRCodePanel';
import DashboardCharts from './components/DashboardCharts';
import CropRotationEngine from './components/CropRotationEngine';
import ResourceDashboard from './components/ResourceDashboard';
import SustainabilityIndex from './components/SustainabilityIndex';
import ConflictResolution from './components/ConflictResolution';
import LearningNetwork from './components/LearningNetwork';
import SMSNotifications from './components/SMSNotifications';
import CropEvaluation from './components/CropEvaluation';
import './styles/index.css';
import './styles/cropRotation.css';
import './styles/resources.css';
import './styles/sustainability.css';

function App() {
  const [showQRCode, setShowQRCode] = useState(false);
  const [activeView, setActiveView] = useState('map');

  const views = [
    { id: 'map', label: 'Map View' },
    { id: 'charts', label: 'Dashboard' },
    { id: 'rotation', label: 'Crop Rotation' },
    { id: 'resources', label: 'Resources' },
    { id: 'sustainability', label: 'Sustainability' },
    { id: 'conflicts', label: 'Conflict Resolution' },
    { id: 'learning', label: 'Learning Network' },
    { id: 'sms', label: 'SMS Notifications' },
    { id: 'evaluation', label: 'Crop Evaluation' }
  ];

  const renderActiveView = () => {
    switch(activeView) {
      case 'map':
        return <MapView />;
      case 'charts':
        return <DashboardCharts />;
      case 'rotation':
        return <CropRotationEngine />;
      case 'resources':
        return <ResourceDashboard />;
      case 'sustainability':
        return <SustainabilityIndex />;
      case 'conflicts':
        return <ConflictResolution />;
      case 'learning':
        return <LearningNetwork />;
      case 'sms':
        return <SMSNotifications />;
      case 'evaluation':
        return <CropEvaluation />;
      default:
        return <MapView />;
    }
  };

  return (
    <div className="app-container">
      <Navbar />
      <div className="dashboard">
        <Sidebar />
        <div className="main-content">
          <div className="view-toggle">
            {views.map(view => (
              <button 
                key={view.id}
                className={`view-toggle-button ${activeView === view.id ? 'active' : ''}`}
                onClick={() => setActiveView(view.id)}
              >
                {view.label}
              </button>
            ))}
          </div>
          
          <div className="view-container" style={{ 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column',
            height: 'calc(100vh - 120px)', // Adjust based on navbar and toggle height
            position: 'relative',
            overflow: 'auto'
          }}>
            {renderActiveView()}
          </div>
          
          {showQRCode && (
            <QRCodePanel onClose={() => setShowQRCode(false)} />
          )}
        </div>
      </div>
    </div>
  );
}

export default App; 